import { useNavigate } from "react-router-dom";
import AuiButton from "../../components/Buttons/Buttons";
import "./NoPermission.scss";
import { AdminRoles } from "../../utils/constants/app-constants";

const NoPermission = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role") ?? "";
  const onBackBtnHandle = () => {
    if (
      userRole === AdminRoles.SponsoringAdmin ||
      userRole === AdminRoles.MasterTrainer ||
      userRole === AdminRoles.ApprovingAdmin
    ) {
      navigate("/course-listing");
    } else if (userRole === AdminRoles.SuperAdmin) {
      navigate("/organization-listing");
    } else {
      navigate("/");
    }
  };
  return (
    <div className="page-404 no-access-page">
      <div className="container">
        <div className="w-100">
          <aui-globalerror errortype="secondary" heading="No Permission">
            <p className="pb-3">
              You don’t have permission to access this page.
            </p>
            <AuiButton
              onClick={onBackBtnHandle}
              className="mt-6 px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
              variant={"primary"}
              buttontitle="Return to home page"
              buttonid={""}
              data-testid="back-button"
            ></AuiButton>
          </aui-globalerror>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
